import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Full from './layouts/Full';
import Default from './layouts/Default';

import Login from './page/Auth/Login';
import Logout from './page/Auth/Logout';
import ForgotPassword from './page/Auth/ForgotPassword';

import Dashboard from './page/Dashboard';
import ChangePassword from './page/Auth/ChangePassword';

import Setting from './page/Setting/Setting';
import EmailSetting from './page/Setting/EmailSetting';
import CommonSetting from './page/Setting/CommonSetting';

import UserList from './page/User/UserList';

import ItemList from './page/Item/ItemList';
import Item from './page/Item/Item';

import KarateList from './page/Karate/KarateList';
import Karate from './page/Karate/Karate';

import ShadeList from './page/Shade/ShadeList';
import Shade from './page/Shade/Shade';

import StoneList from './page/Stone/StoneList';
import Stone from './page/Stone/Stone';

import CategoryList from './page/Category/CategoryList';
import Category from './page/Category/Category';

import SizeList from './page/Size/SizeList';
import Size from './page/Size/Size';

import ProductList from './page/Product/ProductList';

import ReviewsList from './page/Reviews/ReviewsList';

import OrdersList from './page/Orders/Orders';
import OrdersDetail from './page/Orders/OrdersDetail';

function App() {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <Full />,
            children: [
                {
                    path: "",
                    element: <Login />,
                },
                {
                    path: "/forgot-password",
                    element: <ForgotPassword />,
                },
                {
                    path: "/logout",
                    element: <Logout />,
                },
            ],
        },
        {
            path: "/",
            element: <Default />,
            children: [
                {
                    path: "dashboard",
                    element: <Dashboard />,
                },
                {
                    path: "change-password",
                    element: <ChangePassword />,
                },
                {
                    path: "setting",
                    children: [
                        {
                            path: "",
                            element: <Setting />,
                        },
                        {
                            path: "email",
                            element: <EmailSetting />,
                        },
                        {
                            path: "common",
                            element: <CommonSetting />,
                        },
                    ]
                },
                {
                    path: "users",
                    children: [
                        {
                            path: "",
                            element: <UserList />,
                        }
                    ]
                },
                {
                    path: "items",
                    children: [
                        {
                            path: "",
                            element: <ItemList />,
                        },
                        {
                            path: "add",
                            element: <Item />,
                        },
                        {
                            path: "edit/:id",
                            element: <Item />,
                        }
                    ]
                },
                {
                    path: "karates",
                    children: [
                        {
                            path: "",
                            element: <KarateList />,
                        },
                        {
                            path: "add",
                            element: <Karate />,
                        },
                        {
                            path: "edit/:id",
                            element: <Karate />,
                        }
                    ]
                },
                {
                    path: "shades",
                    children: [
                        {
                            path: "",
                            element: <ShadeList />,
                        },
                        {
                            path: "add",
                            element: <Shade />,
                        },
                        {
                            path: "edit/:id",
                            element: <Shade />,
                        }
                    ]
                },
                {
                    path: "stones",
                    children: [
                        {
                            path: "",
                            element: <StoneList />,
                        },
                        {
                            path: "add",
                            element: <Stone />,
                        },
                        {
                            path: "edit/:id",
                            element: <Stone />,
                        }
                    ]
                },
                {
                    path: "categories",
                    children: [
                        {
                            path: "",
                            element: <CategoryList />,
                        },
                        {
                            path: "add",
                            element: <Category />,
                        },
                        {
                            path: "edit/:id",
                            element: <Category />,
                        }
                    ]
                },
                {
                    path: "size",
                    children: [
                        {
                            path: "",
                            element: <SizeList />,
                        },
                        {
                            path: "add",
                            element: <Size />,
                        },
                        {
                            path: "edit/:id",
                            element: <Size />,
                        }
                    ]
                },
                {
                    path: "products",
                    children: [
                        {
                            path: "",
                            element: <ProductList />,
                        }
                    ]
                },
                {
                    path: "reviews",
                    children: [
                        {
                            path: "",
                            element: <ReviewsList />,
                        }
                    ]
                },
                {
                    path: "orders",
                    children: [
                        {
                            path: "",
                            element: <OrdersList />,
                        },
                        {
                            path: "view/:id",
                            element: <OrdersDetail />,
                        }
                    ]
                },
            ],
        }

    ])
    return (
        <RouterProvider router={router} />
    );
}

export default App;